import { ApiKeyList } from '@/features/apiKeys/ApiKeyList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/api-keys')({
  component: ApiKeyList,
})
